import { makeObservable, observable, computed, toJS } from "mobx";
import { isImageFileName } from "../file/utils";
import SessionFile from "./sessionFile";
import {
  ESessionFileContentParseStatus,
  ESessionFileType,
  ISessionFile,
} from "./type";

type IFileMap = Record<string, ISessionFile>;

class SessionFileManager {
  @observable fileList: ISessionFile[] = [];

  constructor(file_list?: ISessionFile[]) {
    if (file_list) {
      this.initFileList(file_list);
    } else {
      this.fileList = [];
    }

    makeObservable(this);
  }

  @computed
  get fileIds() {
    return this.fileList.filter(ele => !!ele.file_id).map(ele => ele.file_id!);
  }

  @computed
  get fileNameMap() {
    const linkFiles = this.fileList.filter(
      ele => ele.type === ESessionFileType.link && !!ele.file_name,
    );
    return linkFiles.reduce((prev: IFileMap, cur) => {
      prev[cur.file_name] = cur;
      return prev;
    }, {});
  }

  @computed
  get linkFileIdMap() {
    const linkFiles = this.fileList.filter(
      ele => ele.type === ESessionFileType.link,
    );
    return linkFiles.reduce((prev: IFileMap, cur) => {
      prev[cur.file_id || ""] = cur;
      return prev;
    }, {});
  }

  initFileList(file_list?: ISessionFile[]) {
    if (file_list) {
      this.fileList = file_list.map(
        file =>
          new SessionFile({
            type:
              file.type ||
              (isImageFileName(file.file_name)
                ? ESessionFileType.image
                : ESessionFileType.file),
            url: file.url,
            file_id: file.file_id,
            file_name: file.file_name,
            status: file.status,
            contentParseStatus:
              file.type !== ESessionFileType.link
                ? ESessionFileContentParseStatus.success
                : file.url && file.status === "success"
                  ? ESessionFileContentParseStatus.parsing
                  : ESessionFileContentParseStatus.failed,
          }),
      );
    } else {
      this.fileList = [];
    }
  }

  deleteFile = (file_id: string) => {};

  addFiles(list: ISessionFile[]) {
    this.fileList.unshift(...list);
  }

  getFileById(file_id: string) {
    return this.fileList.find(ele => ele.file_id === file_id);
  }
}

export default SessionFileManager;
